import { registerComponent } from '@gig/magic-common';
import GamingTransactionsComponent from './gaming.vue.js';

var GamingTransactions = registerComponent(GamingTransactionsComponent);

export { GamingTransactions };
